import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
}), 'SwapVertTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SwapVertTwoTone.js
// module id = 6617
// module chunks = 2